import React from 'react';

type AdSlotSize = 'leaderboard' | 'in-article' | 'sidebar' | 'footer';

const SIZE_MAP: Record<AdSlotSize, { minHeight: string; label: string }> = {
  leaderboard: { minHeight: '90px', label: 'Leaderboard 728x90' },
  'in-article': { minHeight: '250px', label: 'In-Article 300x250' },
  sidebar: { minHeight: '600px', label: 'Sidebar 300x600' },
  footer: { minHeight: '90px', label: 'Footer 728x90' },
};

interface AdSlotProps {
  slot: AdSlotSize;
  /** AdSense ad-unit slot ID, e.g. "1234567890". Leave unset until approved. */
  adSlotId?: string;
  className?: string;
}

/**
 * Reserved, correctly-sized container for a Google AdSense unit.
 *
 * TODO(monetization): once the AdSense account is approved, set
 * VITE_ADSENSE_CLIENT_ID in .env and pass adSlotId here, then replace the
 * placeholder <div> below with:
 *   <ins className="adsbygoogle" style={{ display: 'block' }}
 *        data-ad-client={import.meta.env.VITE_ADSENSE_CLIENT_ID}
 *        data-ad-slot={adSlotId} data-ad-format="auto" data-full-width-responsive="true" />
 * and call (window.adsbygoogle = window.adsbygoogle || []).push({}) after mount.
 * The AdSense loader script itself is scaffolded (commented) in index.html.
 */
export const AdSlot: React.FC<AdSlotProps> = ({ slot, adSlotId, className = '' }) => {
  const { minHeight, label } = SIZE_MAP[slot];

  if (adSlotId) {
    // Real ad unit path — wired in once a publisher ID exists.
    return (
      <div className={className} style={{ minHeight }} data-ad-slot={adSlotId}>
        {/* <ins className="adsbygoogle" ... /> goes here once approved */}
      </div>
    );
  }

  return (
    <div
      className={`flex items-center justify-center rounded-xl border border-dashed border-zinc-800 bg-zinc-950/40 text-[10px] font-medium text-zinc-600 ${className}`}
      style={{ minHeight }}
      aria-hidden="true"
    >
      Ad space reserved — {label}
    </div>
  );
};
